import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "overflow-auto hidden-scrollbar header-content"
}
const _hoisted_3 = { class: "d-flex flex-row" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "overflow-auto hidden-scrollbar header-content" }
const _hoisted_7 = { class: "header" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { class: "overflow-auto hidden-scrollbar header-content" }
const _hoisted_10 = { class: "d-flex flex-row" }
const _hoisted_11 = { class: "header" }
const _hoisted_12 = { class: "text-capitalize-first" }
const _hoisted_13 = { class: "overflow-auto hidden-scrollbar header-content" }
const _hoisted_14 = { class: "header" }
const _hoisted_15 = { class: "text-capitalize-first" }
const _hoisted_16 = { class: "header-content" }
const _hoisted_17 = { class: "games-wrapper" }

import TournamentCard from "@/components/tournaments/TournamentCard.vue";
import TournamentDTO from "@/models/TournamentDTO";
import SvgIcon from "@/components/SvgIcon.vue";
import LiveWin from "@/components/wins/LiveWin.vue";
import LiveWinDTO from "@/models/LiveWinDTO";
import {onMounted, onUnmounted, ref} from "vue";
import {api} from "@/service/APIClient";
import {reactive} from "@vue/reactivity";
import GameDTO from "@/models/GameDTO";
import Welcome from "@/components/banners/Welcome.vue";
import GameIcon from "@/components/games/GameIcon.vue";
import BannerDTO from "@/models/BannerDTO";
import {useStore} from "vuex";
import LoaderContent from "@/components/LoaderContent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const state = reactive({
  banners: [] as BannerDTO[],
  hotGames: [] as GameDTO[],
  liveUpdateInterval: null as number|any
});

const liveWinsLoader = ref<InstanceType<typeof LoaderContent> | null>(null)
const liveTournamentsLoader = ref<InstanceType<typeof LoaderContent> | null>(null)
const hotGamesLoader = ref<InstanceType<typeof LoaderContent> | null>(null)
const favoriteGamesLoader = ref<InstanceType<typeof LoaderContent> | null>(null)

const store = useStore()

const onFavoriteChange = (game: GameDTO) => {
  if (game.isFavorite) {
    store.dispatch('addFavoriteGame', game);
  } else {
    store.dispatch('removeFavoriteGame', game);
  }

  const hotItem = state.hotGames.find(g => g.id === game.id);
  if (hotItem) {
    hotItem.isFavorite = game.isFavorite
  }
}

onMounted(async () => {
  liveWinsLoader.value?.load(async () => {
    await store.dispatch('setLiveWins', await api.call.live.wins())
  });

  liveTournamentsLoader.value?.load(async () => {
    await store.dispatch('setLiveTournaments', await api.call.live.tournaments())
  });

  favoriteGamesLoader.value?.load(async () => {
    await store.dispatch('setFavoriteGames', store.getters.isLoggedIn ? await api.call.games.favorites() : [],)
  });

  hotGamesLoader.value?.load(async () => {
    state.hotGames = await api.call.games.hot()
  });

  state.banners = await api.call.banners.placement('home')
  state.liveUpdateInterval = setInterval(async () => {
    api.call.live.wins().then((resp) => store.dispatch('setLiveWins', resp))
    api.call.live.tournaments().then((resp) => store.dispatch('setLiveTournaments', resp))
  }, 10000);
})

onUnmounted(() => {
  clearInterval(state.liveUpdateInterval);
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(state).banners.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).banners, (banner) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: banner.name
              }, [
                (banner.name ==='welcome')
                  ? (_openBlock(), _createBlock(Welcome, {
                      key: 0,
                      config: banner.config
                    }, null, 8, ["config"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('latest_wins')), 1)
    ]),
    _createVNode(LoaderContent, {
      ref: (el) => liveWinsLoader.value = el
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_TransitionGroup, {
            name: "animation-list",
            tag: "div",
            class: "d-flex flex-row position-relative"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.liveWins, (item, index) => {
                return (_openBlock(), _createBlock(LiveWin, {
                  item: item,
                  key: `${item.createdAt}_${item.gameId}_${item.userId}`
                }, null, 8, ["item"]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(SvgIcon, { icon: "menu/tournaments" }),
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('tournaments')), 1)
    ]),
    _createVNode(LoaderContent, {
      ref: (el) => liveTournamentsLoader.value = el
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.liveTournaments, (item, index) => {
              return (_openBlock(), _createBlock(TournamentCard, {
                item: item,
                key: item.id,
                class: "slide"
              }, null, 8, ["item"]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", {
      class: _normalizeClass([_unref(store).getters.favoriteGames.length === 0 ? 'd-none': ''])
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(SvgIcon, { icon: "my_favs" }),
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('favorite_games')), 1)
      ]),
      _createVNode(LoaderContent, {
        ref: (el) => favoriteGamesLoader.value = el
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_TransitionGroup, {
              name: "animation-list",
              tag: "div",
              class: "d-flex flex-row position-relative"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.favoriteGames, (game, index) => {
                  return (_openBlock(), _createBlock(GameIcon, {
                    onFavoriteChanged: onFavoriteChange,
                    key: game.id,
                    class: "slide",
                    game: game
                  }, null, 8, ["game"]))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 512)
    ], 2),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(SvgIcon, { icon: "menu/games" }),
      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('games')), 1)
    ]),
    _createVNode(LoaderContent, {
      ref: (el) => hotGamesLoader.value = el
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).hotGames, (game, index) => {
              return (_openBlock(), _createBlock(GameIcon, {
                onFavoriteChanged: onFavoriteChange,
                key: game.id,
                game: game
              }, null, 8, ["game"]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_router_link, {
      to: {name: 'games'},
      class: "btn btn-outline-secondary text-capitalize-first all-games-btn"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('all_games')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})